// extracted by mini-css-extract-plugin
export default {"toggleButton":"styles_toggleButton__+oaH8"};